// @flow

import * as React from 'react';
import Box from 'sail/Box';

type TabProps = {|
  children: React.Node,
|};

export const Tab = ({children}: TabProps) => (
  <Box className="TabGroup-Tab">{children}</Box>
);
